import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=56081033&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=56081033&prod&lang=scss"
import style1 from "./Simulator.vue?vue&type=style&index=1&id=56081033&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56081033",
  null
  
)

export default component.exports